import { SERVICES } from "../../configs/constants";

export default {
  display: true,
  title: "Devs",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Mobile App versions",
      icon: "rdv",
      id: "appversions",
      component: "",
      path: "/mobile_app_versions",
      onClick: "",
      minRole: 1
    },
    // { suppression de l'ecran carburant car NDF désormais dans LUCCA
    //   label: "Carburant",
    //   icon: "rdv",
    //   id: "fuel",
    //   component: "",
    //   path: "/fuel",
    //   onClick: "",
    //   minRole: 2
    // },
    // { // suppression de l'écran vehicules car désormais sur mendix
    //   label: "Vehicules",
    //   icon: "rdv",
    //   id: "vehicules",
    //   component: "",
    //   path: "/user_vehicules",
    //   onClick: "",
    //   minRole: 1
    // },
    {
      label: "Backlogs",
      icon: "rdv",
      id: "backlogs",
      component: "",
      path: "/backlogs",
      onClick: "",
      minRole: 1
    },
    {
      label: "Lucca présences",
      icon: "rdv",
      id: "luccaattendances",
      component: "",
      path: "/lucca_attendances",
      onClick: "",
      minRole: 1
    }
    // {
    //   label: "Ancienne gestion des primes",
    //   icon: "premium",
    //   id: "premium",
    //   component: "",
    //   path: "/presence/premium",
    //   onClick: "",
    //   submenu: false,
    //   minRole: 3
    //   // service: SERVICES.Privileges
    // }
  ]
};



// WEBPACK FOOTER //
// src/pages/devs/Menu.js